import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { onSearchDiaRutaClick, onSearchVendedorPorRolClick, onUpdateFieldEntity } from '../../store/roles/actions';

import { ActionField, FieldSet } from '@sigeco/tools';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import InputLabel from '@material-ui/core/InputLabel';
import makeStyles from '@material-ui/core/styles/makeStyles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles(() => ({
    checkbox: {
        color: '#9c9c9c',
        padding: 0,
    },
    chip: {
        margin: '0.375rem 0.375rem 0 0',
    },
    content: {
        padding: '0.5rem 0.75rem 0.75rem',
    },
    label: {
        alignItems: 'center',
        display: 'flex',
        fontSize: '0.8125rem',
    },
}));

const RolForm = () => {
    const classes = useStyles();
    const matches = useMediaQuery('(min-width:701px)');
    const entity = useSelector((state) => state.roles.entity);
    const errors = useSelector((state) => state.roles.errors);
    const formState = useSelector((state) => state.roles.formState);
    const dispatch = useDispatch();
    const isView = formState === 'view';

    const onFieldChange = (event) => dispatch(onUpdateFieldEntity(event.target.name, event.target.value));

    return (
        <div>
            <FieldSet className={classes.paper} iconCls="fas fa-address-card" title="Aplicación">
                <div className={classes.details}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} container>
                            <Grid item xs={matches ? 4 : 12}>
                                <TextField
                                    autoComplete="off"
                                    error={errors.nombre !== ''}
                                    fullWidth
                                    helperText={errors.nombre}
                                    label="Nombre del Rol"
                                    name="nombre"
                                    onChange={onFieldChange}
                                    required
                                    value={entity.nombre}
                                    variant={matches ? 'outlined' : 'standard'}
                                    inputProps={{
                                        maxLength: 120,
                                        readOnly: isView,
                                        //shrink: true
                                    }}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </FieldSet>
        </div>
    );
};

export default RolForm;
